import React from 'react'
import { Box } from '@mui/material'
import config from '../../config/config'
import { LAND_USE_CONTEXT } from '../../constants/roadwayVariables'
import { SubSectionTitle } from './ProjectInputs'
import CustomSlider from './CustomSlider'
import ProjectInfo from './ProjectInfo'
import { Container, CustomDropDown } from './ProjectInputsTwo'
import './ProjectInputs.scss'
const step2Illustration = new URL(
  '../../../../images/illustrations/step2-2x.png',
  import.meta.url
)

export default function ProjectInputsOne() {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '30% 1fr',

        gap: '30px',
        height: '400px'
      }}
      className="project-inputs-main-container"
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        className="img-container"
      >
        <img
          src={step2Illustration}
          style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '100%' }}
        />
      </Box>
      <Box
        sx={{
          display: 'flex'
        }}
        className="inputs-container"
      >
        <Container>
          {config.roadwayVariables
            .filter((roadWayInput) => roadWayInput.field === LAND_USE_CONTEXT)
            .map((roadWayInput) => {
              return (
                <CustomDropDown
                  field={roadWayInput.field}
                  question={roadWayInput.title}
                  key={`${roadWayInput.field}-slider`}
                  dropDownValues={roadWayInput.values}
                />
              )
            })}
          <ProjectInfo />
        </Container>
        <Container>
          {config.roadwayVariables
            .filter((obj, i) => i >= 4 && i <= 6)
            .map((roadWayInput) => {
              return (
                <CustomSlider
                  min={roadWayInput.min}
                  max={roadWayInput.max}
                  step={roadWayInput.step}
                  sliderNote={roadWayInput.notes}
                  notesLink={roadWayInput.notesLink}
                  field={roadWayInput.field}
                  sliderType="roadwayVariables"
                  question={roadWayInput.title}
                  key={`${roadWayInput.field}-slider`}
                  format={roadWayInput.sliderValueFormat}
                />
              )
            })}
        </Container>
      </Box>
    </Box>
  )
}
